import { Link } from '@mui/joy';
import { forwardRef } from 'react';

import { DEFAULT_PLACEHOLDER } from 'core/constants';

export const Email = forwardRef<HTMLAnchorElement, { email: string }>(function Email(
  { email },
  ref
) {
  if (!email) {
    return <>{DEFAULT_PLACEHOLDER}</>;
  }

  return (
    <Link ref={ref} href={`mailto:${email}`}>
      {email}
    </Link>
  );
});
